const MarketTradeButton = ({ background, shadow, children }) => {
  return (
    <button
      type="submit"
      className={`p-[10px] w-full text-white font-normal text-base leading-[24px] flex items-center justify-center rounded-[4px] ${background} ${shadow}`}
    >
      {children}
    </button>
  )
}

export default MarketTradeButton
